export default "__VITE_ASSET__CnXXVnQV__"